import React, { useState, useEffect } from 'react';
import {
  Spin, Button, Card, Modal, Typography
} from 'antd';
import {
  EditOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
// import Fuse from 'fuse.js';
import _ from 'lodash';
import moment from 'moment';
import * as Service from '../core/Service';
import NavAndSideFrame from '../components/NavAndSideFrame';
import TncForm from '../components/TncForm';
import { useTranslation } from 'react-i18next';

const title = `司機隱私權政策`;
const selectedKey = `driver_tnc_list`;
// const filterableField = [
//   'tnc_content'
// ];

const { Title, Paragraph } = Typography;

const DriverTncList = (props) => {
  const {t} = useTranslation();

  const [dataList, setDataList] = useState([]);
  const [unChangeData, setUnChangeData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  // const [isShowPassword, setShowPassword] = useState(false);
  // const [isChangingIsActive, setChangingIsActive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    let endpoint = `/api/driver/tnc`;
    let list = [];
    let defaultFormData = {
      tnc_id: 1,
      tnc_content: ''
    }
    setLoading(true);
    try {
      let data = await Service.call(`GET`, endpoint);
      list = _.orderBy(data, [`ctime`], [`desc`]);
      if (data.errorMessage) list = [];
    } catch (error) {
      console.log(error);
    } finally {
      setDataList(list);
      setUnChangeData(list);
      defaultFormData.tnc_content = list[0].tnc_content;
      setSelectedRecord(defaultFormData);
      setLoading(false);
    }
  }

  const displayMoment = (unixTime, outputFormat = 'YYYY/MM/DD HH:mm') => {
    if (unixTime !== 0) {
      let displayTime = moment.unix(unixTime).format(outputFormat);
      return displayTime;
    }
    return '-';
  }

  const getData = () => {
    console.log("DATA", dataList);
    if (!_.isEmpty(dataList) && !_.isUndefined(dataList)) {
      return dataList[0].tnc_content;
    } else {
      return '';
    }
  }

  // const getDataBySearchKeyword = (keywords) => {
  //   let dataList = [];
  //   try {
  //     const options = {
  //       includeScore: true,
  //       findAllMatches: true,
  //       threshold: 0.15,
  //       keys: filterableField
  //     }
  //     const fuse = new Fuse(unChangeData, options)
  //     const result = fuse.search(keywords);
  //     console.log("RESULT", result);
  //     dataList = _.map(result, 'item');
  //     dataList = _.orderBy(dataList, [`ctime`], [`desc`]);
  //   } catch (error) {
  //     console.error('error >>> ', error);
  //   } finally {
  //     setDataList(dataList);
  //   }
  // }

  // let timeout;
  // const debounce = (func, delay) => {
  //   clearTimeout(timeout);
  //   timeout = setTimeout(func, delay);
  // };

  // const onChange = (keyword) => {
  //   debounce(() => {
  //     getDataBySearchKeyword(keyword);
  //     if (_.isEmpty(keyword)) setDataList(unChangeData);
  //   }, 400);
  // };

  return (
    <NavAndSideFrame {...props} title={title} selectedKey={selectedKey}>
      <Card>
        <Button
          icon={<EditOutlined />}
          style={{ marginRight: 10 }}
          type="primary"
          onClick={() => {
            // setSelectedRecord(defaultFormData);
            setModalVisible(true);
          }}
        >
          修改
        </Button>

        {/* <Space direction="horizontal">
          <>以文字搜尋:</>
          <Input
            placeholder="請輸入文字"
            onChange={(values) => {
              onChange(values.target.value);
            }}
          />
        </Space> */}
      </Card>

      <Card>
        <Spin spinning={loading}>
          <Paragraph>
            <div style={{ 'whiteSpace': 'pre-line' }}>{getData()}</div>
          </Paragraph>
        </Spin>
      </Card>
      <Modal
        title={t('title.driver_term_and_condition')}
        visible={modalVisible}
        footer={null}
        style={{ maxWidth: 800 }}
        width="90%"
        onCancel={() => { setModalVisible(false) }}
      >
        <TncForm
          selectedRecord={selectedRecord}
          openModal={(value) => {
            getAllData();
            setModalVisible(value);
          }}
          involvedModelName='driver'
        />
      </Modal>
    </NavAndSideFrame >
  );
}

export default DriverTncList;
